﻿import { events } from "@grindex-common/helpers/events";
import { baseLink } from "@grindex-common/helpers/baseLink";
import { endsWith } from "@grindex-common/helpers/domManipulation";
import { constants } from "@grindex-components/Accordion/Accordion.constants";
import { $elementChild, $tabModule } from "@grindex-common/helpers/elements";

const CLASS_VISIBLE_DESKTOP = "visible-desktop";
const CLASS_SELECTED = "selected";
const CLASS_SELECTED_TAB = "tab_selected";

const ELEMENT_CONTENT = "accordion-content";

export default class Tab {
	constructor(name, dom) {
		this.tabName = name;
		this.parser = new DOMParser();
		this.order = 0;
		this.dom = dom;
		this.loaded = false;
		this.$headerElement = null;
		this.$contentElement = null;
		this.tryGetTab.bind(this);
	}

	deactivate() {
		this.$contentElement.classList.remove(CLASS_VISIBLE_DESKTOP);
		this.$contentElement.parentElement.classList.remove(constants.CLASS_ACTIVE);
		this.$headerElement.classList.remove(CLASS_SELECTED);
		this.$headerElement.classList.remove(CLASS_SELECTED_TAB);

		if (this.deactivationCallback) {
			this.deactivationCallback();
		}
	}

	activate() {
		this.$contentElement.classList.add(CLASS_VISIBLE_DESKTOP);
		this.$contentElement.parentElement.classList.add(constants.CLASS_ACTIVE);
		this.$headerElement.classList.add(CLASS_SELECTED);
		this.$headerElement.classList.add(CLASS_SELECTED_TAB);

		if (this.activationCallback) {
			this.activationCallback();
		}
	}

	isLoaded() {
		return this.loaded;
	}

	async tryGetTab() {
		return new Promise((resolve) => {
			let currentUrl = baseLink.getBaseLinkWithoutSegments(window.config.tabs);

			if (!endsWith(currentUrl, "/")) {
				currentUrl += "/";
			}

			const apiUrl = `${currentUrl}${this.tabName}tab`;

			this.loadTab(apiUrl);

			resolve("resolved");
		});
	}

	loadTab(apiUrl) {
		fetch(apiUrl, { method: "POST" })
			.then(function (response) {
				if (response) {
					return response.text();
				}

				return null;
			})
			.then(
				function (body) {
					if (body) {
						const doc = this.parser.parseFromString(body, "text/html");

						const $body = doc.querySelector("body");

						this.$module = $tabModule($body);

						this.$headerElement = this.addHeader($body);

						$body.childNodes.forEach(($node) => {
							this.dom.getContentContainer().appendChild($node);
						});

						this.loaded = true;
						this.order = this.$module.getAttribute("xyl-tab-module") * 1;

						this.$contentElement = $elementChild(this.$module, ELEMENT_CONTENT);

						window.dispatchEvent(new CustomEvent(events.TAB_LOADED, { detail: this.tabName }));
						window.dispatchEvent(new CustomEvent(events.tabLoadedEvent(this.tabName)));
					} else {
						window.dispatchEvent(new CustomEvent(events.TAB_LOADED));
					}
				}.bind(this),
			);
	}

	addHeader() {
		const $headerElement = this.dom.createHeader(this.dom.getTabName(this.$module), this.$module);

		const $headers = this.dom.getExistingHeaders();

		if ($headers.length > 0) {
			const $insertBefore = this.dom.getNextLargerHeader($headerElement);

			if ($insertBefore) {
				this.dom.prependTabHeading($headerElement, $insertBefore);
			} else {
				this.dom.appendTabHeading($headerElement);
			}
		} else {
			this.dom.appendTabHeading($headerElement);
		}

		return $headerElement;
	}
}
